import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import { useResizeListener } from '@Hooks/custom/useResizeListener';
import type React from 'react';

interface StepFooterProps {
  id: string;
  title: string;
  onClick: () => void;
  onBackClick: () => void;
  disabled?: boolean;
}

export const StepFooter: React.FC<StepFooterProps> = ({
  title,
  onClick,
  onBackClick,
  disabled = false,
}) => {
  const { isMobile } = useResizeListener();
  return (
    <div className='absolute w-full flex items-center justify-center px-[16px] md:px-[0px] bottom-0 py-[24px] border-t border-surface-primary-bw-03'>
      <div className='flex items-center justify-between max-w-[500px] w-[500px]'>
        {!isMobile && (
          <LiliButton
            id='recovery-back-button'
            title='Back'
            type={LiliButtonType.SECONDARY}
            onClick={onBackClick}
            className='w-[145px]'
          />
        )}
        <LiliButton
          id='recovery-next-button'
          title={title}
          onClick={onClick}
          disabled={disabled}
          className='w-full md:w-[145px]'
        />
      </div>
    </div>
  );
};
